import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface UpdateCustomerRequest {
    payment_memo: string;
}

export const usePutSalesMemo = (
    successCallback?: () => void,
): UseMutationResult<null, Error, { customerId: number; paymentHistoryIdx: number; customerMemoData: UpdateCustomerRequest }> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, { customerId: number; paymentHistoryIdx: number; customerMemoData: UpdateCustomerRequest }>({
        mutationFn: async ({ customerId, paymentHistoryIdx, customerMemoData }) => {
            const response = await axios.put(
                enum_api_uri.put_sales_memo
                    .replace(":customer_idx", customerId?.toString() || "")
                    .replace(":payment_history_idx", paymentHistoryIdx?.toString() || ""),
                customerMemoData,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data.data;
        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ["getPaymentHistory"] });
            successCallback?.();
        },
    });
};
